import { ExerciseDetailsByDate } from '@demind-inc/core';
import { useQuery } from '@tanstack/react-query';

import { API_URL, axiosInstance, dataTrendApi } from '../api';

export interface ExerciseWeeklyTrend {
  dataTrendId: string;
  metricId: string;
  startDate: string;
  endDate: string;
  totalSteps: number;
  totalCalories: number;
  totalDistanceMeters: number;
  activeDays: number;
  activitiesByDate: ExerciseDetailsByDate[];
}

interface UseExerciseWeeklyTrendParams {
  dataTrendId: string;
  metricId: string;
  startDate: string;
  endDate: string;
  enabled?: boolean;
}

interface UseExerciseWeeklyTrendQueryParams {
  queryKey: ['lifestack.trend.exercise.weekly', UseExerciseWeeklyTrendParams];
}

export const useExerciseWeeklyTrend = ({
  dataTrendId,
  metricId,
  startDate,
  endDate,
  enabled = true,
}: UseExerciseWeeklyTrendParams) => {
  const exerciseTrendQuery = useQuery({
    queryKey: [
      'lifestack.trend.exercise.weekly',
      { dataTrendId, metricId, startDate, endDate, enabled },
    ],
    queryFn: ({ queryKey }: UseExerciseWeeklyTrendQueryParams) => {
      const [
        ,
        {
          dataTrendId: queryDataTrendId,
          metricId: queryMetricId,
          startDate: queryStartDate,
          endDate: queryEndDate,
        },
      ] = queryKey;
      return dataTrendApi
        .getExerciseWeeklyTrend(queryMetricId, queryStartDate, queryEndDate, queryDataTrendId)
        .then(({ data }) => data as ExerciseWeeklyTrend);
    },
    refetchOnWindowFocus: false,
    staleTime: 15000,
    enabled: !!dataTrendId && !!metricId && !!startDate && !!endDate && enabled,
  });

  return {
    exerciseTrend: exerciseTrendQuery.data,
    ...exerciseTrendQuery,
  };
};
